import passwordWords from "@/auth/word-lists.json";

function randomIndex(max: number) {
  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return values[0]! % max;
}

function randomWord() {
  return passwordWords[randomIndex(passwordWords.length)] ?? "password";
}

function randomTwoDigitNumber() {
  return String(randomIndex(100)).padStart(2, "0");
}

export function generateSuggestedPassword() {
  return `${Array.from({ length: 4 }, randomWord).join("-")}-${randomTwoDigitNumber()}`;
}
